// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"476":"2c20991f","987":"c1cdd422"}[chunkId] + ".chunk.css";
};